import "core-js/es/promise";
import "core-js/es/set";
import "core-js/es/map";

import { STRING_REQUIRED, FILE_REQUIRED, CANNOT_BE_EMPTY,  } from "../validation/errorTypes";

const handleError = obj => {
    const item = { ...obj, result: null };
    if (obj.type === "typeError" && (obj.value === null || obj.value.length === 0)) {
        Object.assign(item, { result: CANNOT_BE_EMPTY });
    } else if (obj.type === "required" && obj.params.label === "file") {
        Object.assign(item, { result: FILE_REQUIRED });
    } else if (obj.type === "required" || obj.type === "required field") {
        Object.assign(item, { result: STRING_REQUIRED });
    } else if (obj.type === "min" && new RegExp(/Id$/gi).test(obj.params.path)) {
        Object.assign(item, { result: STRING_REQUIRED });
    }
    return item;
};

const handleErrors = data => Object.assign({}, data, { inner: data.inner.map(handleError) });

export default (schema, data) =>
    new Promise((resolve, reject) =>
        schema
            .validate(data, { abortEarly: false })
            .then(resolve)
            .catch(err => reject(handleErrors(err)))
    );
